import { Injectable } from "@angular/core";
import { Observable, of, ReplaySubject } from "rxjs";
import { switchMap } from "rxjs/operators";
import { IssueAuditStatus, IssueAuditWrapper } from "../../../classes";
import { IIssueAuditWrapperProvider } from "../../../interfaces";
import { IssueService } from "../../../services/issue.service";

@Injectable()
export class IssueAuditWrapperComponentService implements IIssueAuditWrapperProvider {

    private _issueAuditWrapper = new ReplaySubject<IssueAuditWrapper>(1);
    issueAuditWrapper$ = this._issueAuditWrapper.asObservable();

    issueStatusCache: { [key: string]: ReplaySubject<IssueAuditStatus> } = {};

    constructor(private _issueService: IssueService) { }

    getIssueStatus(guid: string): Observable<IssueAuditStatus> {
        if (typeof guid !== 'string') return of(null);
        return this.issueAuditWrapper$.pipe(switchMap(x => {
            let status = x.issueStatus.find(y => y.guid === guid);
            if (status) return of(status);
            if (!this.issueStatusCache[guid]) {
                this.issueStatusCache[guid] = new ReplaySubject<IssueAuditStatus>(1);
                this._issueService.getIssueAuditStatus(guid).subscribe((result) => this.issueStatusCache[guid].next(result))
            }
            return this.issueStatusCache[guid].asObservable();
        }))
    }

    setIssueAuditWrapper(wrapper: IssueAuditWrapper) {
        this._issueAuditWrapper.next(wrapper);
    }

}